<button
  tuiButton
  type="button"
  class="category-button"
  [appearance]="selectedCategory?.id === mainCategory?.id ? 'primary' : 'outline'"
  [size]="isDesktop ? 'm' : 's'"
  (click)="onSelect(mainCategory)"
>
  {{ 'common.buttons.all' | translate }}
</button>

<button
  *ngFor="let subCategory of mainCategory?.items"
  tuiButton
  type="button"
  class="category-button category-button_sub"
  [appearance]="selectedCategory?.id === subCategory.id ? 'primary' : 'outline'"
  [size]="isDesktop ? 'm' : 's'"
  (click)="onSelect(subCategory)"
>
  {{ subCategory?.name }}
</button>
